function buildKey(path, options) {
  const withInput = options?.input !== void 0 ? { input: options?.input } : {};
  const withType = options?.type !== void 0 ? { type: options?.type } : {};
  return [path, {
    ...withInput,
    ...withType
  }];
}

function createGeneralUtils(path) {
  return {
    key(options) {
      return buildKey(path, options);
    }
  };
}

function createProcedureUtils(client, options) {
  return {
    call: client,
    queryOptions(...[optionsIn = {}]) {
      return {
        queryKey: buildKey(options.path, { type: "query", input: optionsIn.input }),
        queryFn: ({ signal }) => client(optionsIn.input, { signal, context: optionsIn.context }),
        ...optionsIn
      };
    },
    infiniteOptions(optionsIn) {
      return {
        queryKey: buildKey(options.path, { type: "infinite", input: optionsIn.input(optionsIn.initialPageParam) }),
        queryFn: ({ pageParam, signal }) => {
          return client(optionsIn.input(pageParam), { signal, context: optionsIn.context });
        },
        ...optionsIn
      };
    },
    mutationOptions(...[optionsIn = {}]) {
      return {
        mutationKey: buildKey(options.path, { type: "mutation" }),
        mutationFn: (input) => client(input, { context: optionsIn.context }),
        ...optionsIn
      };
    }
  };
}

function createRouterUtils(client, options = {}) {
  const path = options.path ?? [];
  const generalUtils = createGeneralUtils(path);
  const procedureUtils = createProcedureUtils(client, { path });
  const recursive = new Proxy({
    ...generalUtils,
    ...procedureUtils
  }, {
    get(target, prop) {
      const value = Reflect.get(target, prop);
      if (typeof prop !== "string") {
        return value;
      }
      const nextUtils = createRouterUtils(client[prop], { ...options, path: [...path, prop] });
      if (typeof value !== "function") {
        return nextUtils;
      }
      return new Proxy(value, {
        get(_, prop2) {
          return Reflect.get(nextUtils, prop2);
        }
      });
    }
  });
  return recursive;
}

export { buildKey, createGeneralUtils, createRouterUtils as createORPCReactQueryUtils, createProcedureUtils, createRouterUtils };
